import moment from 'moment';

import {default as Modal} from './modal.js';
import customSelect from './customselect';
import customInputNumber from './form-number';
import {default as Preloader} from './preloader.js';

const QuickBookingForm = function($root, model) {
    this.$root = $root;
    this.model = model;

    this.init();
}

QuickBookingForm.prototype.init = function() {
    this.initDateRangePicker();
};

QuickBookingForm.prototype.getInternalDateFormat = function() {
	return "YYYY-MM-DD";
};

QuickBookingForm.prototype.getCheckinInput = function() {
	return $('input.checkindate');
};

QuickBookingForm.prototype.getCheckoutInput = function() {
	return $('input.checkoutdate');
};

QuickBookingForm.prototype.initDateRangePicker = function() {
    let minDate = moment();

    let maxDate = moment();
    maxDate.add(365, 'days');

    const format = "DD/MM/YYYY";
    const formatParam = this.getInternalDateFormat();;

    let pickerparams = {
        "autoApply": true,
        "autoUpdateInput": false,
        "opens": "right",
        "locale": {
            "format": format
          },
        "minDate": minDate,
        "maxDate": maxDate,
        "alwaysShowCalendars": true,
        "singleDatePicker": true
    };

    const fixedPackageId = parseInt(this.$root.attr('data-offerid'));
    let fixedPackageNights = parseInt(this.$root.attr('data-offernights'));

    const updateDateControlFunc = function($control, newDate) {
        $control.val(newDate.format(formatParam));
        $control.next().find('.value').html(newDate.format(format));
    };

    const $nights = $('input.nights');
    const $checkinInput = $('input.checkindate');
    const $checkoutInput = $('input.checkoutdate');
    const $checkinFormGroup = $('.checkindate-form-group');

    $checkinInput.after('<span class="date-label"><span class="value"></span><i class="fa-regular fa-calendar"></i></span>');

    $checkinFormGroup.on('click', '.date-label', function() {
        $checkinInput.click();
    });

    const $checkoutFormGroup = $('.checkoutdate-form-group');

    $checkoutInput.after('<span class="date-label"><span class="value"></span><i class="fa-regular fa-calendar"></i></span>');

    $checkoutFormGroup.on('click', '.date-label', function() {
        $checkoutInput.click();
    });
    
    let startDate = moment($checkinInput.val());
    let endDate = moment(startDate);
    // endDate.add(2, 'day');

    if (fixedPackageId) {
        pickerparams.maxSpan = {
            "days": fixedPackageNights
        };
        endDate.add(fixedPackageNights, 'day');
    } else {
        let endDate = moment($checkoutInput.val());
    }

    updateDateControlFunc($checkinInput, moment($checkinInput.val()));
    updateDateControlFunc($checkoutInput, moment($checkoutInput.val()));

    $checkinInput.attr('type', 'text').attr('readonly', true);
    $checkoutInput.attr('type', 'text').attr('readonly', true);

    if (!fixedPackageId) {
        $nights.on('change', function() {
            const nights = parseInt($(this).val());
            const start = $checkinInput.data('daterangepicker').startDate;

            let end = moment(start);
            end.add(nights, 'day');

            $checkoutInput.data('daterangepicker').setStartDate(start);
            $checkoutInput.data('daterangepicker').setEndDate(end);

            updateDateControlFunc($checkoutInput, end);
        });
    }

    pickerparams.startDate = startDate;
    pickerparams.endDate = endDate;

    $checkinInput.daterangepicker(pickerparams, function(start, end, label) {
        var min = moment(start);
        min.add(1, 'day');

        let endDate = moment(min);

        if (fixedPackageId) {
            endDate = moment(start);
            endDate.add(fixedPackageNights, 'day');
        } else {
            let checkoutDate = $checkoutInput.data('daterangepicker').endDate;

            if (checkoutDate >= min) {
                endDate = moment(checkoutDate);
            }

            $checkoutInput.data('daterangepicker').minDate = min;
            $checkoutInput.data('daterangepicker').setStartDate(endDate);
            $checkoutInput.data('daterangepicker').setEndDate(endDate);
        }

        updateDateControlFunc($checkinInput, start);
        updateDateControlFunc($checkoutInput, endDate);

        var days = Math.abs(endDate.diff(start, 'days'));
        $nights.val(days);
    });

    if (!fixedPackageId) {
        $checkoutInput.daterangepicker(pickerparams, function(start, end, label) {
            var max = moment(end);
            max.subtract(1, 'day');

            let checkinDate = $checkinInput.data('daterangepicker').startDate;
            let startDate = moment(checkinDate);

            if (max < checkinDate) {
                startDate = moment(max);
            }

            updateDateControlFunc($checkinInput, startDate);
            updateDateControlFunc($checkoutInput, end);

            $checkinInput.data('daterangepicker').setStartDate(startDate);
            $checkinInput.data('daterangepicker').setEndDate(end);

            var days = Math.abs(end.diff(startDate, 'days'));
            $nights.val(days);
        });
    }
};

const CheckAvailabilityForm = function($root, model) {
    QuickBookingForm.apply(this, arguments);

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    const sourceParamValue = urlParams.get('source');

    if (sourceParamValue == 'home') {
        const $btn = this.$root.find('button.book-now');
		$btn.click();
    }
};

CheckAvailabilityForm.prototype = Object.create(QuickBookingForm.prototype);
CheckAvailabilityForm.prototype.constructor = CheckAvailabilityForm;

CheckAvailabilityForm.prototype.init = function() {
    this.initDateRangePicker();
    this.initSubmit();
};

CheckAvailabilityForm.prototype.initNICValidation = function(e) {
    const deferred = jQuery.Deferred();

	const _this = this;
	const $form = this.$root;
    const $currencySelect = $form.find('.currency');

	if ($form.hasClass('require-nic') && $currencySelect.val() == 'LKR') {
		Modal.show('nic-modal', {
			onShown: function($modal) {
				const $verifyNICForm = $modal.find('.verify-nic-form');
				$verifyNICForm.on('submit', function(e) {
					e.preventDefault();

					const url = $verifyNICForm.attr('action');
					let formData = $verifyNICForm.serialize();
					
					formData += '&currency=LKR';

					$.ajax(url, {
						data: formData,
						method: 'POST'
					}).done(function(responseData) {
						//if (responseData.status == "success") {
							$form.removeClass('require-nic');
							$currencySelect.val('LKR').change();
							Modal.hide();

							deferred.resolve();
						//}
					});
				});
			}
		});
	} else {
		deferred.resolve();
	}

	return deferred.promise();
};

CheckAvailabilityForm.prototype.initSubmit = function() {
    const $bookform = this.$root;
    const $btn = this.$root.find('button.book-now');

    const _this = this;
    const _model = this.model;

    $bookform.submit(function (e) {
        e.preventDefault();

		const nicValidation = _this.initNICValidation(e);
		nicValidation.done(function() {
			$btn.html('LOADING');

			$('#whybook').removeClass('hidden');
			$('#couponDiv').addClass('hidden');

			var nights = $("input[name='nights']").val();
			var $daterange = $("input[name='daterange']");
			var rooms = $("input[name='rooms']").val();
			var offerid = $("input[name='specialoffers']").val();

			var Error='';

			if (nights<=0){
				Error = Error + 'Invalid date selection, minimum of 1 night required.'+"<br>";
			}
			if ($daterange.val()==''){
				Error = Error + 'Please enter a valid check-in date & check-out date'+"<br>";
			}

			if (Error){
				$("#mytext").html(Error);
				//$("#myModal").modal('show');
				$btn.html('CHECK AVAILABILITY');
			} else {
				var formData = $bookform.serialize();
				const fetchUrl = $bookform.attr('data-update-url');

				Preloader.start();

				$.ajax(fetchUrl, {
					method: 'POST',
					data: formData
				}).done(function(responseData) {
					Preloader.end();

					if (responseData.status == "error") {
						const errorCode = responseData.code;

						Modal.show("alert-modal", {
							"onSubmit": function() {
								location.reload();
							}
						});
						
						return;
					}

					_this.$root.trigger('fetched', responseData.data);

					$btn.html('CHECK AVAILABILITY');

					_model.setCouponCode('');
					_model.setCouponPercent('');

					const $addCouponWrapper = $('.add-coupon-wrapper');
					$addCouponWrapper.find('.code').val('');
					$addCouponWrapper.find('.msg').hide();
				})
				.fail(function() {
					Modal.show('alert-modal', {});
				});
			}
		});
    });

}

export {
    QuickBookingForm,
    CheckAvailabilityForm
};